<template>
  <div class="cardAuth">
    <nav-bar title="车辆认证"></nav-bar>
    <div class="bgc"></div>
    <div class="img">
      <van-uploader
        upload-text="行驶证正面"
        :after-read="afterRead"
        :deletable="true"
        v-model="positive"
        :max-count="1"
      />
      <van-uploader
        upload-text="行驶证反面"
        :after-read="afterRead2"
        v-model="reverse"
        :deletable="true"
        :max-count="1"
      />
      <van-uploader
        upload-text="车辆照片"
        :after-read="afterRead3"
        v-model="carpto"
        :deletable="true"
        :max-count="1"
      />
    </div>
    <div class="problem" @click="problem()">
      <img src="@/assets/icon/warning.png" alt="" />
      <span>以下信息为系统自动识别，如不正确请修改《常见问题》</span>
    </div>
    <div class="from">
      <div class="item">
        <span>城市代码</span>
        <van-field
          v-model="cityCode"
          input-align="right"
          placeholder="请输入城市代码"
        />
      </div>
      <div class="item">
        <span>城市名称</span>
        <van-field
          v-model="cityName"
          input-align="right"
          placeholder="请输入城市名称"
        />
      </div>
      <div class="item">
        <span>区代吗</span>
        <van-field
          v-model="countyCode"
          input-align="right"
          placeholder="请输入区代码"
        />
      </div>
      <div class="item">
        <span>车辆品牌</span>
        <van-field
          v-model="carBrand"
          input-align="right"
          placeholder="请输入车辆类型"
        />
      </div>
      <div class="item">
        <span>品牌型号</span>
        <van-field
          v-model="brandModel"
          input-align="right"
          placeholder="请输入品牌型号"
        />
      </div>
      <div class="item">
        <span>检验记录</span>
        <van-field
          v-model="testRecord"
          input-align="right"
          placeholder="请输入检验记录"
        />
      </div>

      <div class="item">
        <span>区名称</span>
        <van-field
          v-model="countyName"
          input-align="right"
          placeholder="请输入区名称"
        />
      </div>
      <div class="item">
        <span>地址</span>
        <van-field
          v-model="address"
          input-align="right"
          placeholder="请输入地址"
        />
      </div>

      <div class="item">
        <span>省/自治区代码</span>
        <van-field
          v-model="provinceCode"
          input-align="right"
          placeholder="请输入省/自治区代码"
        />
      </div>
      <div class="item">
        <span>省名</span>
        <van-field
          v-model="provinceName"
          input-align="right"
          placeholder="请输入省名"
        />
      </div>
      <div class="item">
        <span>车辆颜色</span>
        <van-field
          v-model="carColor"
          input-align="right"
          placeholder="请输入车辆颜色"
        />
      </div>
      <div class="item">
        <span>车辆识别代号</span>
        <van-field
          v-model="carVehicleIdentification"
          input-align="right"
          placeholder="请输入车辆识别代号"
        />
      </div>

      <div class="item">
        <span>用户id</span>
        <van-field
          v-model="id"
          input-align="right"
          placeholder="请输入用户id"
        />
      </div>

      <div class="item">
        <span>最后一次更新用户</span>
        <van-field
          v-model="updateUser"
          input-align="right"
          placeholder="请输入最后一次更新用户"
        />
      </div>
      <div class="item">
        <span> 审核拒绝理由</span>
        <van-field
          v-model="auditReason"
          input-align="right"
          placeholder="请输入核定载人数"
        />
      </div>

      <div class="item">
        <span>核定载质量</span>
        <van-field
          v-model="approvedQuality"
          input-align="right"
          placeholder="请输入核定载质量"
        />
      </div>
      <div class="item">
        <span>牵引总质量</span>
        <van-field
          v-model="tractionTotalQuality"
          input-align="right"
          placeholder="请输入牵引总质量"
        />
      </div>
      <div class="item">
        <span>最后一次更新时间</span>
        <van-field
          v-model="updateTime"
          input-align="right"
          placeholder="请输入最后一次更新时间"
        />
      </div>
      <div class="item">
        <span>车辆尾号</span>
        <van-field
          v-model="carEndNumber"
          input-align="right"
          placeholder="请输入核定载质量"
        />
      </div>

      <div class="item">
        <span>发动机编号</span>
        <van-field
          v-model="engineNumber"
          input-align="right"
          placeholder="请输入发动机编号"
        />
      </div>

      <div class="item">
        <span>外廓尺寸</span>
        <van-field
          v-model="outsideDimensions"
          input-align="right"
          placeholder="请输入外廓尺寸"
        />
      </div>
      <div class="item">
        <span>总质量</span>
        <van-field
          v-model="totalQuality"
          input-align="right"
          placeholder="请输入外廓尺寸"
        />
      </div>
      <div class="item">
        <span>备注</span>
        <van-field
          v-model="remarks"
          input-align="right"
          placeholder="请输入备注"
        />
      </div>

      <div class="item">
        <span>车牌号</span>
        <van-field
          v-model="carNumber"
          input-align="right"
          placeholder="请输入车牌号"
        />
      </div>
      <div class="item">
        <span>档案编号</span>
        <van-field
          v-model="fileNumber"
          input-align="right"
          placeholder="请输入档案编号"
        />
      </div>
      <div class="item">
        <span>发证日期</span>
        <van-field
          v-model="sendCadTime"
          input-align="right"
          placeholder="请输入档案编号"
        />
      </div>
      <div class="item">
        <span>拥有者id企业或账户</span>
        <van-field
          v-model="ownerId"
          input-align="right"
          placeholder="拥有者id企业或账户"
        />
      </div>
      <div class="item">
        <span>车辆所有人</span>
        <van-field
          v-model="ownerName"
          input-align="right"
          placeholder="请输入车辆所有人"
        />
      </div>
      <div class="rdo">
        <span>车辆类型 </span>
        <van-radio-group
          v-model="ownerType"
          v-for="(ownerty, index) in ownertypes"
          :key="index"
          class="rdos"
        >
          <van-radio :name="ownerty.value">{{ ownerty.label }}</van-radio>
        </van-radio-group>
      </div>
      <div class="item">
        <span>注册日期</span>
        <van-field
          v-model="registerTime"
          input-align="right"
          placeholder="请输入注册日期"
        />
      </div>
      <div class="item">
        <span> 核定载人数</span>
        <van-field
          v-model="personsApprovedNum"
          input-align="right"
          placeholder="请输入核定载人数"
        />
      </div>
      <div class="item">
        <span>审核人姓名</span>
        <van-field
          v-model="auditName"
          input-align="right"
          placeholder="请输入审核人姓名"
        />
      </div>
      <div class="item">
        <span>项目id</span>
        <van-field
          v-model="projectId"
          input-align="right"
          placeholder="请输入项目id"
        />
      </div>
      <div class="item">
        <span>项目服务区域id</span>
        <van-field
          v-model="projectServiceId"
          input-align="right"
          placeholder="请输入项目服务区域id"
        />
      </div>
      <div class="item">
        <span> 车载设备pn</span>
        <van-field
          v-model="pn"
          input-align="right"
          placeholder="请输入车载设备pn"
        />
      </div>
      <div class="item">
        <van-cell title="开始时间" :value="date3" @click="showsj3 = true" />
        <van-calendar
          v-model="showsj3"
          @confirm="onConfirm3"
          :min-date="minDate3"
          :max-date="maxDate3"
        />
      </div>
      <div class="item">
        <span> 车辆出厂时间</span>
        <van-field
          v-model="productionDate"
          input-align="right"
          placeholder="请输入车辆出厂时间"
        />
      </div>
      <div class="rdo">
        <span>审核状态 </span>
        <van-radio-group
          v-model="auditStatus"
          direction="horizontal"
          class="rdos"
        >
          <van-radio name="0">未审核</van-radio>
          <van-radio name="1">审核通过</van-radio>
          <van-radio name="2">审核不通过</van-radio>
        </van-radio-group>
      </div>
      <div class="rdo">
        <span>是否删除</span>
        <van-radio-group v-model="delFlag" direction="horizontal" class="rdos">
          <van-radio name="0">否</van-radio>
          <van-radio name="1">是</van-radio>
        </van-radio-group>
      </div>
      <div class="rdo">
        <span> 是否允许其他项目选择</span>
        <van-radio-group
          v-model="isAllowOtherProjectChoose"
          direction="horizontal"
          class="rdos"
        >
          <van-radio name="0">否</van-radio>
          <van-radio name="1">是</van-radio>
        </van-radio-group>
      </div>
      <div class="rdo">
        <span> 同一项目其他区域选择</span>
        <van-radio-group
          v-model="isAllowOtherRegionChoose"
          direction="horizontal"
          class="rdos"
        >
          <van-radio name="0">否</van-radio>
          <van-radio name="1">是</van-radio>
        </van-radio-group>
      </div>
      <div class="type">
        <span>车辆状态</span>
        <van-radio-group
          v-model="carStatus"
          v-for="(item, index) in driversts"
          :key="index"
          class="rdos"
        >
          <van-radio :name="item.value">{{ item.label }}</van-radio>
        </van-radio-group>
      </div>
      <div class="rdo">
        <span>车型</span>
        <van-radio-group
          v-model="cartes"
          direction="horizontal"
          v-for="(item2, index) in carte"
          :key="index"
          class="rdos"
        >
          <van-radio :name="item2.value">{{ item2.label }}</van-radio>
        </van-radio-group>
      </div>
      <div class="rdo">
        <span>车动力能源</span>
        <van-radio-group v-model="carPower" direction="horizontal" class="rdos">
          <van-radio name="0">燃油 </van-radio>
          <van-radio name="1">新能源</van-radio>
        </van-radio-group>
      </div>
      <div class="rdo">
        <span>是否默认个人车辆</span>
        <van-radio-group
          v-model="carDefault"
          direction="horizontal"
          class="rdos"
        >
          <van-radio name="0">否</van-radio>
          <van-radio name="1">是</van-radio>
        </van-radio-group>
      </div>
      <div class="rdo">
        <span>是否禁用</span>
        <van-radio-group
          v-model="forbidden"
          direction="horizontal"
          class="rdos"
        >
          <van-radio name="0">否</van-radio>
          <van-radio name="1">是</van-radio>
        </van-radio-group>
      </div>
      <div class="item">
        <span>整备质量</span>
        <van-field
          v-model="curbWeight"
          input-align="right"
          placeholder="请输入整备质量"
        />
      </div>
      <div class="item">
        <span>创建时间</span>
        <van-field
          v-model="createTime"
          input-align="right"
          placeholder="请输入创建时间"
        />
      </div>
      <div class="item">
        <span>创建人</span>
        <van-field
          v-model="createUser"
          input-align="right"
          placeholder="请输入创建人"
        />
      </div>
    </div>

    <div class="btn">
      <van-checkbox v-model="checked" icon-size="14px"
        ><span @click.stop="ststus">App车辆认证协议</span>
      </van-checkbox>
      <van-button type="primary" color="rgba(33,37,41,1)" block @click="addcar"
        >添加车辆
      </van-button>
    </div>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";

import {
  Field,
  Checkbox,
  Dialog,
  Button,
  Uploader,
  RadioGroup,
  Radio,
  Calendar,
  Cell,
} from "vant";

export default {
  name: "cardAuth",
  data() {
    return {
      // 选中协议
      checked: false,
      date3: "",
      showsj3: false,
      minDate3: new Date(1999, 0, 1),
      maxDate3: new Date(2210, 0, 31),
      // 地址
      address: null,
      // 	核定载质量
      approvedQuality: null,

      // 审核人姓名
      auditName: null,
      // 用户id（uid）
      id: null,
      // 拒绝审核理由
      auditReason: null,
      // 审核状态
      auditStatus: null,
      // 车辆品牌
      carBrand: null,
      // 车辆识别代号
      carVehicleIdentification: null,
      //  品牌型号/
      brandModel: "",
      //车辆颜色
      carColor: "",
      //档案编号
      fileNumber: "",
      //发动机编号
      engineNumber: "",
      //总质量
      totalQuality: "",
      //车辆状态
      carStatus: "",
      //牵引总质量
      tractionTotalQuality: "",
      //项目id
      projectId: "",
      // 车型
      cartes: "",
      // 	核定载人数
      personsApprovedNum: "",
      // 车辆尾号
      carEndNumber: "",
      // 车辆出厂时间
      productionDate: "",
      // 拥有者id企业或账户
      ownerId: "",
      // 	车辆所有人
      ownerName: "",
      // 车辆类型 企业；个人
      ownerType: "",
      // 车辆照片 多个图片
      carImg: "",
      // 车牌号
      carNumber: "",
      // 项目服务区域id
      projectServiceId: "",
      // 省/自治区代码
      provinceCode: "",
      // 创建时候
      createTime: "",
      // 省名
      provinceName: "",
      // 备注
      remarks: "",
      // 是否禁用
      forbidden: "",
      // 检验记录
      testRecord: "",
      // 发证日期
      sendCadTime: "",
      // 注册日期
      registerTime: "",
      // 城市代码
      cityCode: "",
      // 城市名称
      cityName: "",
      // 区代码
      countyCode: "",
      // 是否默认个人车辆
      carDefault: "",
      // 区名称
      countyName: "",
      // 最后一次更新时间
      updateTime: "",
      // 最后一次更新用户account
      updateUser: "",
      // 创建人
      createUser: "",
      // 车载设备pn
      pn: "",
      // 外廓尺寸
      outsideDimensions: "",
      // 车都动力能源
      carPower: "",
      // 是否删除
      delFlag: "",
      // 整备质量
      curbWeight: "",
      // 	是否允许其他项目选择
      isAllowOtherProjectChoose: "",
      // 	同一项目其他区域选择
      isAllowOtherRegionChoose: "",
      // idCard: require("@/assets/icon/icon_4.png"),
      radio: "",
      // driveCard: require("@/assets/logo.png"),
      // 车辆状态
      driversts: [],
      // 车型
      carte: [],
      // 行驶证正面
      positive: [],
      // 行驶证反面
      reverse: [],
      // 行驶证正面
      carpto: [],
      ownertypes: [],
    };
  },
  components: {
    NavBar,
    "van-field": Field,
    "van-checkbox": Checkbox,
    "van-button": Button,
    "van-uploader": Uploader,
    "van-radio-group": RadioGroup,
    "van-radio": Radio,
    "van-cell": Cell,
    [Dialog.Component.name]: Dialog.Component,

    "van-calendar": Calendar,
  },
  created() {
    this.driverstatus();
    this.cartype();
    this.ownertype();
  },

  methods: {
    // 车辆状态
    driverstatus() {
      this.$axios
        .get("/admin/dict/type/vedm_driver_status", {
          headers: {
            Authorization: "Bearer GNi-OaSKCX-qjyrfgv1hTH-mJH0", //token换成从缓存获取
          },
        })
        .then((res) => {
          console.log(res.data.data, "司机状态");
          this.driversts = res.data.data;
        });
    },
    // 车型
    cartype() {
      this.$axios
        .get("/admin/dict/type/vedm_car_type", {
          headers: {
            Authorization: "Bearer GNi-OaSKCX-qjyrfgv1hTH-mJH0", //token换成从缓存获取
          },
        })
        .then((res) => {
          console.log(res.data.data, "车型");
          this.carte = res.data.data;
        });
    },
    // 车型
    ownertype() {
      this.$axios
        .get("/admin/dict/type/vedm_owner_type", {
          headers: {
            Authorization: "Bearer GNi-OaSKCX-qjyrfgv1hTH-mJH0", //token换成从缓存获取
          },
        })
        .then((res) => {
          console.log(res.data.data, "车辆自己的车型");
          this.ownertypes = res.data.data;
        });
    },
    async afterRead(file) {
      let fd = new FormData();
      // let that =this
      fd.append("file", file.file);
      // console.log(fd,"行驶证正面")
      await this.$axios
        .post(
          "/vedm/vedmOcr/getOcrVehicle",
          {
            page: "face",
            fd,
          },
          {
            headers: {
              Authorization: "Bearer GNi-OaSKCX-qjyrfgv1hTH-mJH0",
              "Content-Type": "multipart/form-data",
            },
          }
        )
        .then((res) => {
          console.log(res, "行驶证正面");
          //
          // let that =this
          // fd.append("multipartFile",file.file);
          // this.$axios
          //   .post("/vedm/systemApp/uploadify/abc", fd, {
          //     headers: {
          //       Authorization: "Bearer GNi-OaSKCX-qjyrfgv1hTH-mJH0",
          //       "Content-Type": "multipart/form-data",
          //     },
          //   })
          //   .then(function (res) {
          //     console.log(res);
          //     // that.positive="https://oss.ihaogo.com/"+res.data.data

          //     console.log(that.positive);
          //   })
          //   .catch(function (error) {
          //     console.log(error);
          //   });
        });
    },
    afterRead2(file) {
      // 此时可以自行将文件上传至服务器

      // this.file.push(file)  // postData是一个数组

      let fd = new FormData();
      let that = this;
      fd.append("multipartFile", file.file);
      this.$axios
        .post("/vedm/systemApp/uploadify/abc", fd, {
          headers: {
            Authorization: "Bearer GNi-OaSKCX-qjyrfgv1hTH-mJH0",
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (res) {
          console.log(res);
          // that.reverse="https://oss.ihaogo.com/"+res.data.data;
          console.log(that.reverse);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    afterRead3(file) {
      // 此时可以自行将文件上传至服务器

      // this.file.push(file)  // postData是一个数组

      let fd = new FormData();
      let that = this;
      fd.append("multipartFile", file.file);
      this.$axios
        .post("/vedm/systemApp/uploadify/abc", fd, {
          headers: {
            Authorization: "Bearer GNi-OaSKCX-qjyrfgv1hTH-mJH0",
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function (res) {
          console.log(res);
          //  that.carpto="https://oss.ihaogo.com/"+res.data.data;
          console.log(that.carpto);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    formatDate3(date3) {
      return `${date3.getFullYear()}-${
        date3.getMonth() + 1
      }-${date3.getDate()} 00:00:00`;
    },
    onConfirm3(date3) {
      this.showsj3 = false;
      this.date3 = this.formatDate3(date3);
      //测试时间

      console.log(date3);
    },
    addcar() {
      if (this.checked) {
        let data = {
          address: this.address,
          approvedQuality: this.approvedQuality,
          auditName: this.auditName,
          auditReason: this.auditReason,
          auditStatus: this.auditStatus,
          auditTime: "2020-12-29 08:40:00",
          brandModel: this.brandModel,
          carBrand: this.carBrand,
          carColor: this.carColor,
          carDefault: this.carDefault,
          carEndNumber: this.carEndNumber,
          carImg: "",
          carNumber: this.carNumber,
          carPower: this.carPower,
          carStatus: this.carStatus,
          carType: this.cartes,
          carVehicleIdentification: this.carVehicleIdentification,
          cityCode: this.cityCode,
          cityName: this.cityName,
          countyCode: this.countyCode,
          countyName: this.countyName,
          createTime: "2020-12-28 07:27:00",
          createUser: this.createUser,
          curbWeight: this.curbWeight,
          delFlag: this.delFlag,
          drivingPermitBack: "",
          drivingPermitFace: "",
          engineNumber: this.engineNumber,
          fileNumber: this.fileNumber,
          forbidden: this.forbidden,
          id: this.id,
          isAllowOtherProjectChoose: this.isAllowOtherProjectChoose,
          isAllowOtherRegionChoose: this.isAllowOtherRegionChoose,
          outsideDimensions: this.outsideDimensions,
          ownerId: this.ownerId,
          ownerName: this.ownerName,
          ownerType: this.ownerType,
          personsApprovedNum: this.personsApprovedNum,
          pn: this.pn,
          productionDate: "2020-12-30",
          projectId: this.projectId,
          projectServiceId: this.projectServiceId,
          provinceCode: this.provinceCode,
          provinceName: this.provinceName,
          registerTime: "2020-12-28",
          remarks: this.remarks,
          sendCadTime: "2020-12-28",
          testRecord: this.testRecord,
          totalQuality: this.totalQuality,
          tractionTotalQuality: this.tractionTotalQuality,
          updateTime: "2020-12-29 09:45:00",
          updateUser: this.updateUser,
        };
        this.$axios
          .post("/vedm/driverH5App/addDriverCarStore", data, {
            headers: {
              Authorization: "Bearer KG8Eok0zlV4P1g5ch2Lo5v0o5bU", //token换成从缓存获取
            },
          })
          .then((res) => {
            console.log(res);
            if (res.data.code == 0) {
              Dialog.alert({
                message: res.data.code,
              });
            } else {
              Dialog.alert({
                message: res.data.code,
              });
            }
          });
      } else {
        Dialog.alert({
          message: "请选中协议",
        });
      }
    },
    ststus() {
      this.$router.push({ name: "protocol" });
    },
    problem() {
      this.$router.push({ name: "problem" });
    },
  },
};
</script>

<style scoped lang="less">
.rdo {
  display: flex;
  font-size: 12px;
  color: grey;
  padding-left: 0.3rem;
  margin-top: 0.2rem;
}
.rdo .rdos {
  font-size: 12px;
  color: grey;
  margin-left: 0.2rem;
}
.type {
  display: flex;
  padding-left: 0.2rem;
  font-size: 12px;
  flex-wrap: wrap;
}
.cardAuth {
  width: 100%;
  box-sizing: border-box;
  background: rgba(247, 247, 247, 1);
  .bgc {
    height: 7px;
  }
  .img {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 6px 15px;
    background-color: #fff;
    .idCard,
    .driveCard {
      width: 165px;
      height: 110px;
    }
    .item {
      text-align: center;
      .title {
        display: inline-block;
        margin: 8px 0;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(158, 160, 165, 1);
      }
      .content {
        position: relative;
      }
      .upload {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        background-color: #414d5c;
        opacity: 0.6;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
          width: 30px;
        }
        span {
          display: block;
          color: #ffffff;
          font-size: 14px;
        }
      }
      .uploaded {
        width: 100%;
        height: 30px;
        position: absolute;
        bottom: 0;
        left: 0;
        background-color: #414d5c;
        opacity: 0.6;
        text-align: center;
        img {
          width: 14px;
          vertical-align: middle;
        }
        span {
          color: #ffffff;
          display: inline-block;
          margin-left: 6px;
          font-size: 12px;
          vertical-align: middle;
        }
      }
    }
  }
  .again {
    display: flex;
    justify-content: space-around;
    padding: 0 15px;
    background-color: #fff;
    p {
      margin: 0;
      font-size: 14px;
      color: #f79e27;
    }
  }
  .problem {
    padding: 0 21px;
    background-color: #fff;
    img {
      width: 14px;
    }
    span {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(196, 198, 205, 1);
      vertical-align: middle;
      margin-left: 6px;
    }
  }
  .from {
    background-color: #fff;
    .item {
      height: 49px;
      padding: 0 15px;
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(158, 160, 165, 1);
      }
      .van-field {
        width: 221px;
        position: absolute;
        right: 0;
      }
    }
  }
  .btn {
    width: 375px;
    height: 112px;
    background: rgba(255, 255, 255, 1);
    margin-top: 30px;
    padding: 15px 25px;
    box-sizing: border-box;
    .van-checkbox {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(98, 104, 112, 1);
    }
    .van-button {
      margin-top: 18px;
    }
  }
  .Insurance {
    display: flex;
    align-items: center;
    padding: 0 15px;
    width: 375px;
    height: 75px;
    background: rgba(255, 255, 255, 1);
    margin-top: 12px;
    img {
      width: 68px;
      height: 45px;
    }
    .text {
      p {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(33, 37, 41, 1);
        margin: 0;
      }
      span {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(158, 160, 165, 1);
      }
    }
  }
}
</style>
